import React, { useState } from 'react';
import { Modal, Input, Button, Alert, Form, Typography, Space, Divider } from 'antd';
import { UserOutlined, LockOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordDialog from './ForgotPasswordDialog';

const LoginDialog = ({ open, onClose, isLimitReached = false }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  // 根據isLimitReached顯示不同的標題和內容
  const title = isLimitReached ? '請登錄以繼續使用' : '用戶登錄';
  const description = isLimitReached 
    ? null
    : '登錄賬戶以獲得「無限制」公司代碼查詢 和 逐字稿查詢。';

  const handleSubmit = async (values) => {
    setError('');
    setLoading(true);

    try {
      await login(values.email, values.password);
      onClose();
      //navigate('/notice');
    } catch (err) {
      setError(err.response?.data?.message || '登錄失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    onClose();
    navigate('/register');
  };

  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
  };

  const handleClose = () => {
    form.resetFields();
    setError('');
    setLoading(false);
    if (onClose) onClose();
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
      width={500}
    >
      <div style={{ padding: '20px 0' }}>
        {isLimitReached ? (
          <div style={{ display: 'block', marginBottom: 16, lineHeight: 1.8 }}>
            <div style={{ color: '#ff4d4f', fontWeight: 600 }}>您已達到未登錄用戶的每週搜索限制 (2次)</div>
            <div>
            立即註冊/登錄解鎖 免費使用！
            <div style={{ color: '#1890ff', fontWeight: 600 }}> ＊  公司代碼查詢 無限上限</div>
            <div style={{ color: '#1890ff', fontWeight: 600 }}> ＊  逐字稿查詢 無限上限</div>
            <div style={{ color: '#1890ff', fontWeight: 600 }}> ＊  20年財務數據 免費查詢</div>
            <div style={{ color: '#faad14', fontWeight: 600 }}> ＊  AI分析查詢 限額20次</div>
             
             
            </div>
          </div>
        ) : (
          <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            {description}
          </Typography.Text>
        )}
        
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            label="電子信箱"
            name="email"
            rules={[
              { required: true, message: '請輸入電子信箱' },
              { type: 'email', message: '請輸入有效的電子信箱' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="請輸入您的電子信箱"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item
            label="密碼"
            name="password"
            rules={[
              { required: true, message: '請輸入密碼' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="請輸入您的密碼"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 16, textAlign: 'right' }}>
            <Button
              type="link"
              size="small"
              icon={<QuestionCircleOutlined />}
              onClick={handleForgotPasswordClick}
              style={{ padding: 0, height: 'auto', fontSize: '12px' }}
            >
              忘記密碼？
            </Button>
          </Form.Item>

          <Form.Item style={{ marginBottom: 16 }}>
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Button onClick={handleClose} disabled={loading}>
                取消
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={isLimitReached ? { 
                  backgroundColor: '#f50057',
                  borderColor: '#f50057'
                } : {}}
              >
                登錄
              </Button>
            </Space>
          </Form.Item>
        </Form>

        <Divider />
        
        <div style={{ textAlign: 'center' }}>
          <Typography.Text type="secondary">
            還沒有賬號？{' '}
            <Button 
              type="link" 
              onClick={handleRegisterClick}
              style={{ padding: 0, height: 'auto' }}
            >
              立即註冊
            </Button>
          </Typography.Text>
        </div>
      </div>

      {/* 忘記密碼對話框 */}
      <ForgotPasswordDialog
        open={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
      />
    </Modal>
  );
};

export default LoginDialog; 